<template>
  <div :class="['chips-category', property1, className]">
    <img
      v-if="property1 === 'variant-2'"
      class="tabler-check"
      alt="Tabler check"
      :src="tablerCheck"
    />
    <div class="tout">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: "ChipsCategory",
  props: {
    property1: {
      type: String,
      validator: function (value) {
        return ["variant-2", "default"].indexOf(value) !== -1;
      },
    },
    className: {
      type: String,
      default: "",
    },
    tablerCheck: {
      type: String,
      default: "/img/tabler-check.svg",
    },
    text: {
      type: String,
      default: "Tout",
    },
  },
};
</script>

<style>
.chips-category {
  align-items: center;
  border-radius: 100px;
  display: inline-flex;
  gap: 8px;
  justify-content: center;
  padding: 4px 12px;
  position: relative;
}

.chips-category .tabler-check {
  height: 16px;
  position: relative;
  width: 16px;
}

.chips-category .tout {
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.chips-category.default {
  border: 0.5px solid;
  border-color: #163518;
}

.chips-category.variant-2 {
  background-color: #e6e3b580;
  box-shadow: 0px 2px 4px #00000040;
}

.chips-category.default .tout {
  color: #163518;
  font-family: "Mona-Sans-Light", Helvetica;
  font-weight: 300;
  margin-top: -0.50px;
}

.chips-category.variant-2 .tout {
  color: #3b723e;
  font-family: "Mona-Sans-SemiBold", Helvetica;
  font-weight: 600;
  margin-top: -1.00px;
}
</style>